// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

.modal-body {
  width: 500px;
  font-size: 14px;
}

.form-group {
  margin-bottom: 1rem;
}

.input-label {
  display: block;
}



.fullrow {
  width: 100%;
}

:host ::ng-deep .p-inputnumber,
p-inputnumber{
  width: 100%;
}
:host ::ng-deep .p-calendar{
  width: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/app/pages/plan/new-hire/new-hire-class-dialog/new-hire-class-dialog.component.css"],"names":[],"mappings":";;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;;;AAIA;EACE,WAAW;AACb;;AAEA;;EAEE,WAAW;AACb;AACA;EACE,WAAW;AACb","sourcesContent":["\n\n.modal-body {\n  width: 500px;\n  font-size: 14px;\n}\n\n.form-group {\n  margin-bottom: 1rem;\n}\n\n.input-label {\n  display: block;\n}\n\n\n\n.fullrow {\n  width: 100%;\n}\n\n:host ::ng-deep .p-inputnumber,\np-inputnumber{\n  width: 100%;\n}\n:host ::ng-deep .p-calendar{\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
